import gql from 'graphql-tag'

export default gql`query {
	getUsers {
		id
		firstName
		lastName
		email
		created_at
	}
}`


// WEBPACK FOOTER //
// ./src/apollo/graphql/user/getUsers.js